import { css } from '@emotion/react';
import { FEE_ITEM_TYPE, FeeItem, formatCurrency } from 'shared';

import { theme } from '../theme';

import { PointsSummary } from './internal/CartPoints';

const styles = {
  container: css`
    white-space: nowrap;
  `,
  fee: (align: 'left' | 'right', small: boolean) => css`
    font-size: ${small ? theme.fontSize.sm : theme.fontSize.md};
    font-weight: ${theme.fontWeight.black};
    margin: 0;
    display: flex;
    justify-content: ${align === 'right' ? 'flex-end' : 'flex-start'};
  `,
};

type Props = {
  pos: string;
  small?: boolean;
  feeItems: FeeItem[];
  align?: 'left' | 'right';
  fallback?: 'points' | 'revenue';
  isSarRebooking?: boolean;
};

export const LegacyCartTotal = ({ pos, feeItems, align = 'right', small = false, isSarRebooking = false }: Props) => {
  const totalPrice = feeItems.find(row => row.itemType === FEE_ITEM_TYPE.Total);

  const totalTax = feeItems.reduce((sum, row) => {
    return row.itemType === FEE_ITEM_TYPE.Taxes ? sum + row.amount : sum;
  }, 0);

  const points = feeItems.find(row => row.itemType === FEE_ITEM_TYPE.Points);

  if (points) {
    return (
      <PointsSummary
        pos={pos}
        points={points}
        totalTax={isSarRebooking ? totalPrice?.amount ?? 0 : totalTax}
        align={align}
        small={small}
      />
    );
  }

  return (
    totalPrice?.amount != null && (
      <div css={styles.container}>
        <p css={styles.fee(align, small)}>{formatCurrency(totalPrice.amount, pos)}</p>
      </div>
    )
  );
};
